import * as Views from "./views";
//import * as Wizards from "./wizards";

const Module = {
    name: "activityOutcomes",
    defaultRoutePath: "/settings/activityOutcome",
    menuItemScope: "settings",
    menuItemName: "activityOutcomes",

    routes: [
        {
            path: "/settings/activityOutcome",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
    ],

}

export default Module;
